import extend from '@/utils/vuex-extend';
import {dialog} from '@/vuex-extend';
import {wait} from '@/utils/wait';
import {listDepot} from "@/api/pcm/purchase";

export default extend(dialog, {
	namespaced: true,
	state: {
		form: {},
		depotList: [],
		multipleSelection: []
	},
	actions: {
		async afterOpenDialog({dispatch, state, commit}, payload) {
			await wait(dispatch, 'pcm.purdemand.depot', async function () {
				const response = await listDepot();
				if (response.data) {
					commit('save', {
						depotList: response.data
					})
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/purdemand/generate.js